export default __webpack_public_path__ + "../staticImages/sprite-forecast-post_ch.png";